module.exports = function () {
  return "\n    <div id=\"cardfan\" class=\"cardfan\">\n    </div>\n  ";
};